import { liveHost } from "@/utils/host";
import imageUrl from "@/utils/imageUrl";
import classNames from "classnames";
import styles from "./index.module.less";

/**
 * @param {{
 *   src?: string;
 *   user?: any;
 *   size?: string;
 *   imgClassName?: string;
 * }} query
 */
export default function UserAvatar({
  src,
  user,
  size = "normal",
  imgClassName,
}) {
  if (user?.extra?.teaching) {
    return (
      <a
        className={classNames([
          styles.avatar,
          size === "normal" ? styles.normal : null,
        ])}
        href={`//${liveHost}/live/${user?.extra?.teaching}`}
        target="_blank"
        rel="noreferrer"
      >
        <div className={styles.img}>
          <img
            src={
              src ||
              imageUrl(user?.avatar, {
                width: size === "normal" ? 32 : 180,
                rect: "sq",
              })
            }
            alt={user?.username}
          />
        </div>
        <div className={styles.circle}></div>
        <div className={styles.label}>
          <img
            className={styles.icon}
            src="//cdn.dancf.com/fe-assets/img/7461c2a98d4da11cc3d8b3fe28e63a52.gif"
            alt="直播中"
          />
          <div className={styles.text}>直播中</div>
        </div>
      </a>
    );
  } else {
    return (
      <div
        className={classNames([
          styles.avatar,
          size === "normal" ? styles.normal : null,
        ])}
      >
        <div className={classNames([styles.img, imgClassName])}>
          <img
            src={
              src ||
              imageUrl(user?.avatar, {
                width: size === "normal" ? 32 : 180,
                rect: "sq",
              })
            }
            alt={user?.username}
          />
        </div>
      </div>
    );
  }
}
